var _rect, _rect2, _g, _rect3, _rect4, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLearningTrails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 342,
    viewBox: "0 0 342 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 153.408,
    y: 78.3418,
    width: 170.54,
    height: 215.419,
    rx: 4,
    transform: "rotate(13.2865 153.408 78.3418)",
    fill: "#393939"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90.4685,
    y: 59.1562,
    width: 170.54,
    height: 215.419,
    rx: 4,
    fill: "#8C52FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33052_2979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.568 134.325H190.885V128.155C190.884 124.519 189.575 121.004 187.197 118.253C184.82 115.502 181.532 113.698 177.935 113.17C174.337 112.642 170.67 113.426 167.602 115.378C164.535 117.331 162.272 120.321 161.227 123.804C161.121 124.156 161.086 124.527 161.123 124.893C161.161 125.26 161.27 125.615 161.445 125.939C161.62 126.263 161.857 126.55 162.142 126.783C162.428 127.015 162.756 127.189 163.109 127.295C163.462 127.401 163.832 127.436 164.199 127.398C164.565 127.361 164.921 127.252 165.245 127.077C165.569 126.902 165.856 126.665 166.088 126.38C166.321 126.094 166.495 125.765 166.601 125.412C167.26 123.22 168.685 121.338 170.617 120.11C172.548 118.881 174.857 118.388 177.122 118.721C179.386 119.054 181.456 120.189 182.953 121.921C184.45 123.653 185.274 125.866 185.275 128.155V133.203C185.275 133.501 185.157 133.786 184.946 133.997C184.736 134.207 184.45 134.325 184.153 134.325H158.909C157.718 134.325 156.577 134.798 155.735 135.64C154.893 136.482 154.421 137.623 154.421 138.813V162.375C154.421 163.565 154.893 164.706 155.735 165.548C156.577 166.39 157.718 166.863 158.909 166.863H192.568C193.758 166.863 194.899 166.39 195.741 165.548C196.583 164.706 197.056 163.565 197.056 162.375V138.813C197.056 137.623 196.583 136.482 195.741 135.64C194.899 134.798 193.758 134.325 192.568 134.325ZM175.738 154.521C174.851 154.521 173.983 154.258 173.245 153.765C172.507 153.271 171.932 152.571 171.592 151.75C171.252 150.93 171.163 150.028 171.336 149.157C171.51 148.287 171.937 147.487 172.565 146.86C173.192 146.232 173.992 145.805 174.863 145.631C175.733 145.458 176.636 145.547 177.456 145.887C178.276 146.226 178.977 146.802 179.47 147.54C179.963 148.278 180.226 149.145 180.226 150.033C180.226 151.223 179.753 152.365 178.912 153.206C178.07 154.048 176.928 154.521 175.738 154.521Z",
    fill: "#EEE7FF"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5411,
    y: 216.232,
    width: 134.637,
    height: 35.9031,
    rx: 4,
    fill: "#C9B3FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81.4927,
    y: 229.695,
    width: 98.7336,
    height: 8.97578,
    rx: 4,
    fill: "#EEE7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283.402 19.4707C282.512 25.091 280.235 30.4035 276.78 34.9251C275.809 36.1959 275.562 37.8755 276.156 39.3607C276.751 40.845 278.088 41.8911 279.667 42.1413C285.287 43.0312 290.6 45.3078 295.121 48.7631C296.392 49.7342 298.072 49.9809 299.557 49.3867C301.041 48.7923 302.087 47.4548 302.338 45.8751C303.227 40.2548 305.504 34.9432 308.959 30.4216C309.93 29.1508 310.177 27.4712 309.583 25.986C308.989 24.5017 307.651 23.4556 306.072 23.2054C300.452 22.3155 295.14 20.039 290.619 16.5837C289.348 15.6127 287.668 15.3659 286.183 15.9601C284.698 16.5535 283.652 17.891 283.402 19.4707Z",
    fill: "#FFE5CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2302 218.904C22.775 221.779 21.6104 224.497 19.8428 226.81C19.3461 227.46 19.2198 228.319 19.5238 229.079C19.8279 229.838 20.512 230.373 21.3197 230.501C24.1947 230.957 26.9124 232.121 29.2254 233.889C29.8755 234.385 30.7347 234.512 31.4944 234.208C32.2537 233.904 32.7889 233.219 32.9169 232.411C33.3721 229.536 34.5367 226.819 36.3042 224.506C36.801 223.856 36.9272 222.997 36.6232 222.237C36.3192 221.478 35.635 220.943 34.8273 220.815C31.9523 220.359 29.2351 219.195 26.9221 217.427C26.272 216.931 25.4128 216.804 24.653 217.108C23.8934 217.412 23.3582 218.096 23.2302 218.904Z",
    fill: "#C9B3FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33052_2979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.8547,
    height: 53.8547,
    fill: "white",
    transform: "translate(148.811 113.008)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningTrails);
export default __webpack_public_path__ + "static/media/learning-trails.37f336ae6dd7fafba8fb63f353293edf.svg";
export { ForwardRef as ReactComponent };